<template>
  <div :style="grayBg ? 'background: #fcfcfc;' : ''" class="pl-5 pr-2">
    <div class="indicator">
      <div class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <div
            class="indicator__dot mr-5 ml-2"
            :class="
              indicator.type === 'success'
                ? 'indicator__dot--success'
                : 'indicator__dot--error'
            "
          ></div>
          <span>
            {{ indicator.name }}
          </span>
        </div>
        <v-tooltip top :max-width="tooltipMaxWidth">
          <template v-slot:activator="{ on }">
            <v-btn text icon v-on="on" @click="show = !show">
              <v-icon :color="indicator.type">
                {{ icon }}
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ $t("message.tooltip.indicator") }}
          </span>
        </v-tooltip>
      </div>
    </div>
    <transition name="fade">
      <div v-show="show">
        <vue-markdown
          class="indicator__info px-4 text--secondary"
          :anchorAttributes="{ target: '_blank', rel: 'nofollow' }"
        >
          {{ indicator.description }}
        </vue-markdown>
      </div>
    </transition>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown-v2";
export default {
  name: "AuditSummaryIndicator",
  components: {
    VueMarkdown
  },
  props: {
    indicator: {
      type: Object,
      default: () => {}
    },
    grayBg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      tooltipMaxWidth: 500
    };
  },

  computed: {
    icon() {
      return this.indicator.type === "success"
        ? "mdi-information-outline"
        : "icon-status-danger";
    }
  }
};
</script>

<style lang="scss" scoped>
.indicator {
  padding: $spacing * 2 0;

  &--error {
    color: $danger;
  }

  &--success {
    color: $success;
  }
}

.indicator__dot {
  height: 8px;
  width: 8px;
  min-width: 8px;
  border-radius: 10px;

  &--error {
    background: $danger;
  }

  &--success {
    background: $success;
  }
}

.indicator-alert__icon {
  font-size: 20px;
}

.indicator__info {
  font-size: 15px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
